module.exports = __webpack_public_path__ + "ee49558a66c282450e62aa230854245a.png";